import api from "../global/Api";
import { ENDPOINTS } from "../global/ApiEndpoints";

// Create budget
export const createBudget = async (budget) => {
  const response = await api.post(`/${ENDPOINTS.BUDGET}`, budget);
  return response.data;
};

// Does the torispherical vessel calculations
export const calculateTorisphericalVessel = async (id) => {
  const response = await api.post(`/${ENDPOINTS.BUDGET}/${id}/calculate-torispherical-vessel`);
  return response.data;
}


// Does the cylindrical shell calculations
export const calculateCylindricalShell = async (id) => {
  const response = await api.post(`/${ENDPOINTS.BUDGET}/${id}/calculate-cylindrical-shell`);
  return response.data;
}


// Does the dished dead shell calculations
export const calculateDishedHead = async (id) => {
  const response =  await api.post(`/${ENDPOINTS.BUDGET}/${id}/calculate-dished-head`);
  return response.data;
}

// Does the dished dead shell calculations
export const calculateVacuumBreaker = async (id) => {
  const response =  await api.post(`/${ENDPOINTS.BUDGET}/${id}/calculate-vacuum-breaker`);
  return response.data;
}

// Does the budget cost calculations
export const calculateBudgetCost = async (id, language) => {
  const response = await api.post(`/${ENDPOINTS.BUDGET}/${id}/calculate-budget-cost`, null, {
    params: { language: (language || "pt").toUpperCase() },
  });
  return response.data;
}

// Update an existing budget
export const updateBudget = async (id, budget) => {
  try {
    const response = await api.put(`/${ENDPOINTS.BUDGET}/${id}`, budget);
    return response.data;
  } catch (error) {
    console.error("Error updating budget:", error.response?.data || error.message);
    throw error;
  }
};

export const getAllBudgets = async (page, size, searchString) => {
  const response = await api.get(`/${ENDPOINTS.BUDGET}`, {
    params: {
      page,
      size,
      search: searchString,
    },
  });

  return response.data;
};

// Get budget dimensions (measurements/specifications)
export const getBudgetDimensions = async (id) => {
  const response = await api.get(`/${ENDPOINTS.BUDGET}/${id}/dimensions`);
  return response.data;
};

// Generate budget dimensions PDF (cover + full calculation sections).
// The payload carries the already-rendered rows so the PDF mirrors the UI 1:1.
export const generateBudgetDimensionsPdf = async (id, language, payload) => {
  const response = await api.post(`/pdf-service/budget/${id}/generate`, payload, {
    params: { language: (language || "pt").toUpperCase() },
    responseType: "blob",
  });
  return response.data;
};

// Get pipe specifications (DN table)
export const getPipeSpecifications = async () => {
  const response = await api.get(`/${ENDPOINTS.BUDGET}/pipe-specifications`);
  return response.data;
};

// List all budgets (unpaginated, for import selection)
export const listAllBudgets = async () => {
  const response = await api.get(`/${ENDPOINTS.BUDGET}`, {
    params: { page: 0, size: 1000, search: "" }
  });
  return response.data.content;
};

// Delete budget
export const deleteBudget = async (id) => {
  const response = await api.delete(`/${ENDPOINTS.BUDGET}/${id}`);
  return response.data;
};
